import { LevelDef } from '../level';
import { ENDURO } from './enduro';
import { ZIELONKA, ZIELONKA_PADDOCK } from './zielonka';

/**
 * Ids are progression keys: 'ring' = the drills (now on the Zielonka paddock), 'track' = laps of MX Zielonka.
 * Both share one real-world level; enduro stays fictional.
 */
export const LEVELS = { ring: ZIELONKA_PADDOCK, track: ZIELONKA, enduro: ENDURO } satisfies Record<string, LevelDef>;
export type LevelId = keyof typeof LEVELS;

/** Terrain grids a level needs loaded before `new Level` (see src/sim/dem.ts). */
export const levelTerrain = (id: LevelId): string | undefined => (LEVELS[id] as LevelDef).terrain?.name;
